import { render, staticRenderFns } from "./TopUp.modal.vue?vue&type=template&id=3a458880&scoped=true&"
import script from "./TopUp.modal.vue?vue&type=script&lang=js&"
export * from "./TopUp.modal.vue?vue&type=script&lang=js&"
import style0 from "./TopUp.modal.vue?vue&type=style&index=0&id=3a458880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a458880",
  null
  
)

export default component.exports